var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',_vm._l((Object.keys(_vm.patientInfo)),function(kkk){return _c('div',{key:kkk},[_c('b',[_vm._v(" "+_vm._s(_vm.$commonfunc.capitalize(kkk))+": ")]),_vm._v(" "+_vm._s(_vm.patientInfo[kkk]))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }